// extracted by mini-css-extract-plugin
export default {"footer":"wikgKWvjm7vT5y5I_vv2","footerMobile":"w89cl8K7PbfljsKzrK7F","version":"LpSVJpFbiW5Lo5aGdTzi"};